// src/utils/backdropClose.js
// Fix for the §13.5 modal drag-close bug: a drag that STARTS inside a modal (e.g. selecting text in a
// field) and releases past the modal edge fires a `click` whose target is the backdrop — closing the
// modal and losing unsaved edits. The web `click` fires on the nearest common ancestor of mousedown +
// mouseup, so NEITHER `onClick={onClose}` NOR `e.target===e.currentTarget` can tell a real backdrop
// click from a drag-out (both see the backdrop as the click target).
//
// This closes ONLY when the mousedown STARTED on the backdrop:
//   - normal backdrop click   -> down on backdrop, up on backdrop -> CLOSES (unchanged)
//   - drag from inside -> out  -> down on content -> does NOT close (the bug)
//   - click on content         -> click target isn't the backdrop -> does NOT close
//
// The module-scoped flag is safe: a single user interacts with one backdrop at a time (a mousedown and
// then its click), so there is never an interleaved second backdrop interaction to corrupt it.
//
// Usage — one-line swap on the backdrop div:  <div {...backdropProps(onClose)} style={overlay}> … </div>
let startedOnBackdrop = false;

export function backdropProps(onClose) {
  return {
    onMouseDown: (e) => { startedOnBackdrop = e.target === e.currentTarget; },
    onClick: (e) => {
      if (e.target === e.currentTarget && startedOnBackdrop) onClose();
      startedOnBackdrop = false;
    },
  };
}
